import React from 'react';
import { SearchResultsProps, DocumentCategoryResultsProps, SearchResult } from './types';
import { BiddingResultItem, DocumentResultItem, NewsResultItem, ServiceResultItem } from './ResultItems';

export function DocumentCategoryResults({ documentsByCategory, handleResultClick }: DocumentCategoryResultsProps) {
  return (
    <>
      {Object.entries(documentsByCategory).map(([category, subcategories]) => (
        <div key={category} className="mb-6">
          <h3 className="text-sm font-semibold text-gray-700 mb-3">{category}</h3>
          {Object.entries(subcategories).map(([subcategory, docs]) => (
            <div key={subcategory} className="mb-4">
              <h4 className="text-xs font-medium text-gray-500 mb-2 pl-2 border-l-2 border-gray-300">{subcategory}</h4>
              <div className="space-y-2">
                {docs.map(doc => (
                  <DocumentResultItem 
                    key={`document-${doc.id}`}
                    result={doc} 
                    onClick={() => handleResultClick(doc)}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
}

export function SearchResults({ results, handleResultClick, activeTab }: SearchResultsProps) {
  if (activeTab === 'documents' && !Array.isArray(results) && 'documentsByCategory' in results) {
    return (
      <div className="space-y-4">
        {Object.keys(results.documentsByCategory).length > 0 ? (
          <DocumentCategoryResults 
            documentsByCategory={results.documentsByCategory}
            handleResultClick={handleResultClick}
          />
        ) : (
          <p className="text-center py-8 text-gray-500">
            Nenhum documento encontrado
          </p>
        )}
      </div>
    );
  }

  if (!Array.isArray(results) || results.length === 0) {
    return (
      <p className="text-center py-8 text-gray-500">
        Nenhum resultado encontrado
      </p>
    );
  }

  return (
    <div className="space-y-4">
      {results.map(result => {
        switch (result.type) {
          case 'news':
            return (
              <NewsResultItem 
                key={`${result.type}-${result.id}`}
                result={result} 
                onClick={() => handleResultClick(result)}
              />
            );
          case 'bidding':
            return (
              <BiddingResultItem 
                key={`${result.type}-${result.id}`}
                result={result} 
                onClick={() => handleResultClick(result)}
              />
            );
          case 'service':
          case 'quicklink':
            return (
              <ServiceResultItem 
                key={`${result.type}-${result.id}`}
                result={result} 
                onClick={() => handleResultClick(result)}
              />
            );
          case 'document':
            return (
              <DocumentResultItem 
                key={`${result.type}-${result.id}`}
                result={result} 
                onClick={() => handleResultClick(result)}
              />
            );
          default:
            return (
              <DocumentResultItem 
                key={`${result.type}-${result.id}`}
                result={result} 
                onClick={() => handleResultClick(result)}
              />
            );
        }
      })}
    </div>
  );
}